<template>
  <section id="quick-links">
    <div>
      <Card
        v-for="(data, i) in linksData.filter((el) => el !== undefined && el !== null)"
        :key="`quick-link-${i}`"
        :heading="data.heading"
        :content="data.description"
        :imgUrl="sortUrl(data.imageUrl)"
        :toUrl="sortUrl(data.toUrl)"
        :imgAltText="data.imageAltText"
        :tag="data.tag ? data.tag : null"
        :date="data.listedTime ? data.listedTime : null"
      />
    </div>
  </section>
</template>

<script>
import Card from '@/components/Card.vue';
import { isEmptyString } from '@general/js/utils';

export default {
  name: 'QuickLinks',
  components: {
    Card,
  },

  props: {
    linksData: {
      type: Array,
      required: true,
    },
  },

  methods: {
    sortUrl(url) {
      if (isEmptyString(url)) {
        return '';
      }

      return url.replace(/~/i, '');
    },
  },
};
</script>

<style lang="scss" scoped>
#quick-links {
  margin: spacer(4) 0;

  div {
    display: grid;
    grid-template-columns: repeat(3, 30%);
    justify-content: space-between;
    row-gap: hutter(1);

    @include mobile {
      grid-template-columns: 1fr;
      row-gap: hutter(0.75);
    }

    .card {
      margin-bottom: 0;
    }
  }
}
</style>
